"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProvidersConstraint = void 0;
const isProvidersConstraint = (constraint) => {
    return constraint.name === 'providers';
};
exports.isProvidersConstraint = isProvidersConstraint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXJzLmNvbnN0cmFpbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RyYWludHMvcHJvdmlkZXJzLmNvbnN0cmFpbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBVU8sTUFBTSxxQkFBcUIsR0FBRyxDQUFDLFVBQTBCLEVBQXFDLEVBQUU7SUFDckcsT0FBTyxVQUFVLENBQUMsSUFBSSxLQUFLLFdBQVcsQ0FBQTtBQUN4QyxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==